export const faqConfig = {
  questions: [
    {
      title: 'What is a Rights of Establishment?',
      description:
        'Individuals from CARICOM Member States who are self-employed have the right to participate in non-wage earning activities such as commerce, industry, agriculture, or artisanal pursuits.\n\nClick to visit our website at: https://mlss.gov.jm for more information.',
    },
    {
      title: 'Who is qualified to obtain a work permit or exemption?',
      description:
        'Visit our website for more details.',
    },
    {
      title: 'What is the cost for a Work permit?',
      description:
        'Visit our website for more details.',
    },
    {
      title: 'Who can apply for a marriage exemption?',
      description:
        'Visit our website for more details.',
    },
    {
      title: 'What is the turn around time for a work permit?',
      description:
        'Visit our website for more details.',
    },
    {
      title: 'What is a CSME?',
      description:
        'Visit our website for more details.',
    },
    {
      title: 'Where can I collect my work permit card?',
      description:
        'Visit our website for more details.',
    },
  ],
};
